export interface FAQItem {
  q: string;
  a: string;
}

export const faqs: FAQItem[] = [
  {
    q: "What sources do you support?",
    a: "We support PDF, Word (DOCX), and PowerPoint (PPTX) files, YouTube video links, and website URLs. Scanned and image-based PDFs work too — our AI handles it all.",
  },
  {
    q: "How does YouTube video processing work?",
    a: "Our AI watches the entire video — including slides, diagrams, and spoken content — and generates flashcards from everything it sees. No transcript needed. Just paste the link.",
  },
  {
    q: "How accurate are the AI-generated flashcards?",
    a: "Our AI produces high-quality question-answer pairs that capture key concepts. You can always edit, delete, or add cards after generation to fine-tune your deck.",
  },
  {
    q: "Do I have to study inside SnapCards, or can I take cards elsewhere?",
    a: "SnapCards is first a study app — flashcards, spaced repetition, and quiz mode built in. Pro also includes a one-click Anki .apkg backup if you ever want a portable copy. We keep that option for peace of mind, not because you're expected to leave.",
  },
  {
    q: "Is there a free trial for Pro?",
    a: "The Starter plan is free forever — unlimited study sessions, 5 AI generations per month, and up to 3 decks. No credit card needed. Upgrade when you want unlimited AI or bigger decks.",
  },
  {
    q: "What is spaced repetition?",
    a: "Spaced repetition is a study technique that shows you flashcards at increasing intervals. Cards you struggle with appear more often, while easy cards appear less. It's scientifically proven to improve long-term retention.",
  },
];
